module.exports = __webpack_public_path__ + "static/media/2.63ae33c9.png";